import { apiFetch } from "../shared/api"
import { RecommendOffer } from "../../../components/Thanks/types"

const RECOMMEND_OFFERS_ENDPOINT = "/api/v1/new_member_recommendations"

type RecommendOffersResponse = {
    status: "success" | "not_logged_in" | "error"
    data?: { offers: RecommendOffer[] }
}

/** サンクス用レコメンド求人を取得。失敗/未ログイン時は空配列(枠非表示)。 */
export const fetchRecommendOffers = async (): Promise<RecommendOffer[]> => {
    try {
        const res = await apiFetch<RecommendOffersResponse>(
            RECOMMEND_OFFERS_ENDPOINT
        )
        return res.status === "success" ? res.data?.offers ?? [] : []
    } catch {
        return []
    }
}
